import(/* webpackMode: "eager", webpackExports: ["FadeIn"] */ "/home/runner/work/MONADATY/MONADATY/components/motion/FadeIn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Reveal"] */ "/home/runner/work/MONADATY/MONADATY/components/Reveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SafeImage"] */ "/home/runner/work/MONADATY/MONADATY/components/SafeImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/MONADATY/MONADATY/node_modules/next/dist/client/app-dir/link.js");
